import { useNavigate } from 'react-router-dom';
import { Spinner } from '@design-system';
import { insightsSummaryPath } from '../lib/paths';
import { StepFooter } from './step-footer';

/** Shown while the plan loads: a centred spinner, with Back available in the footer bar. */
export function ConsumerLoadingState({ clientId }: { clientId: string }) {
  const navigate = useNavigate();
  const canGoBack = (window.history.state?.idx ?? 0) > 0;

  return (
    <div className="flex flex-1 items-center justify-center" data-testid="consumer-flow-loading">
      <Spinner className="size-6" />
      <StepFooter onBack={() => (canGoBack ? navigate(-1) : navigate(insightsSummaryPath(clientId)))} />
    </div>
  );
}
